@if (workLine) {
  <div
    class="work-line expand-panel"
    [class.work-line-selected]="workLine.isSelected"
    [ngStyle]="{ 'padding-left.px': getIndentation(), 'padding-right.px': 39 }"
  >
    <div class="work-line-details object-border">
      <div class="title">
        <span class="description-text">{{ workLine.description }}</span>
        <div class="tags">
          <span class="property-tag"
            >{{ 'workOrderObject.progressType' | translate }}: {{ workLine.progressType }}</span
          >
          <span class="property-tag">Work Type: {{ workLine.workType }}</span>
        </div>
      </div>
      <div class="work-line-progress">
        <div [ngStyle]="{ 'padding-left.px': indentationPerStep * (level + 1) }">
          {{ getProgressLabel(workLine.progress) }}
        </div>
      </div>
      <div class="work-line-select">
        <mat-checkbox
          class="mat-checkbox-xl"
          [checked]="workLine.isSelected"
          (click)="$event.stopPropagation()"
          (change)="toggleSelectedWorkLine(workLine)"
        >
        </mat-checkbox>
      </div>
      <div class="object-expand"></div>
    </div>
  </div>
}
